import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";

export const InsertSchoolProfile = async (formData) => {
  return commonFetch("SchoolDashboard/insert/SchoolProfile", {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const UpdateSchoolProfile = async (id,formData) => {
  return commonFetch(`SchoolDashboard/UpdateSchoolProfileById?id=${id}`, {
    method: "PUT",
    body: formData,
    requiresAuth: true,
  });
};

export const getSchoolByID = async (schoolID) => {
   return commonFetch(`SchoolDashboard/GetSchoolProfileById?SchoolID=${schoolID}`, {
    method: "GET",
    requiresAuth: true,
    headers: {
      accept: "*/*",
    },
  });
};

export const GetAdminprofile = async (AdminID,schoolID) => {
   return commonFetch(`${API_URLS.ADMIN_PROFILE}?AdminID=${AdminID}&SchoolID=${schoolID}`, {
    method: "GET",
    requiresAuth: true,
    headers: {
      accept: "*/*",
    },
  });
};

export const UpdateAdminProfileData = async (formData) => {
  return commonFetch(`${API_URLS.UPDATE_ADMIN_PROFILE}`, {
    method: "PUT",
    body: formData,
    requiresAuth: true,
  });
};


export const BulkUploadStudentRegistration = async (schoolId, formData) => {
  return commonFetch(`${API_URLS.BULK_UPLOAD_STUDENT_REGISTRATION}/${schoolId}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const BulkUploadEmployeeRegistration = async (schoolId, formData) => {
  return commonFetch(`${API_URLS.BULK_UPLOAD_EMPLOYEE_REGISTRATION}/${schoolId}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};